// Third-party libraries
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { FirstStatsStatusType } from '@/lib/firstStats/firstStatsStatus';
// Constants/Libs
import { FIRST_STATS_STATUS } from '@/lib/firstStats/firstStatsStatus';

// Components
import H2 from '@/components/base/Headings/H2';

type HeaderProps = {
    firstStatsStatus: FirstStatsStatusType;
};

const Header = ({ firstStatsStatus }: HeaderProps) => {
    const { t } = useTranslation('commons');

    const getTitle = () => {
        switch (firstStatsStatus) {
            case FIRST_STATS_STATUS.READY:
                return t('modal_first_stats_status.title.ready');
            case FIRST_STATS_STATUS.RELAUNCH:
            case FIRST_STATS_STATUS.RELAUNCH_FAILED:
                return t('modal_first_stats_status.title.relaunch');
            default:
                return t('modal_first_stats_status.title.welcome');
        }
    };

    const getBaseline = () => {
        switch (firstStatsStatus) {
            case FIRST_STATS_STATUS.READY:
                return t('modal_first_stats_status.description.ready');
            case FIRST_STATS_STATUS.RELAUNCH:
                return t('modal_first_stats_status.description.relaunch_first_time');
            case FIRST_STATS_STATUS.RELAUNCH_FAILED:
                return t('modal_first_stats_status.description.relaunch');
            default:
                return t('modal_first_stats_status.description.loading');
        }
    };

    return (
        <>
            <H2 className="mb-5">{getTitle()}</H2>
            <p className="mb-10 font-GMedium text-sm text-icoGray-500">{getBaseline()}</p>
        </>
    );
};

export default Header;
